import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getFixedPreferenceDefaults } from "../fixedPreferenceForm";

const CROWN_MATERIALS = [
  "Céramique sur zircone",
  "Full zircone",
  "Zircone multicouche",
  "e.max",
  "Céramo-métallique",
];
const INLAY_ONLAY_MATERIALS = ["Full zircone", "e.max", "Composite"];
const VENEER_MATERIALS = ["Facette e.max", "Facette feldspathique"];
const TEMPORARY_MATERIALS = ["PMMA", "Composite"];
const SUPPLEMENTS = [
  "Aucun par défaut",
  "Fraisage",
  "Translucidité",
  "Joint céramique",
];

export const CrownPreferences = withForm({
  defaultValues: getFixedPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "crownMaterial",
      "inlayOnlayMaterial",
      "veneerMaterial",
      "temporaryMaterial",
      "supplement",
    ]);

    return (
      <SaveableCard
        title="Couronnes, inlays, onlays, facettes"
        description="Matériaux proposés en premier"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Couronne</Text>
              <form.Field name="crownMaterial">
                {field => (
                  <Select
                    data={CROWN_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Inlay / onlay</Text>
              <form.Field name="inlayOnlayMaterial">
                {field => (
                  <Select
                    data={INLAY_ONLAY_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Facette</Text>
              <form.Field name="veneerMaterial">
                {field => (
                  <Select
                    data={VENEER_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Provisoire</Text>
              <form.Field name="temporaryMaterial">
                {field => (
                  <Select
                    data={TEMPORARY_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Suppléments proposés</Text>
            <form.Field name="supplement">
              {field => (
                <Group>
                  {SUPPLEMENTS.map(supplement => (
                    <ButtonCheckbox
                      key={supplement}
                      id={supplement}
                      isActive={field.state.value === supplement}
                      onClick={() => field.handleChange(supplement)}
                    >
                      {supplement}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
